import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { DocumentType, DocumentTypeEvent } from '../alldocuments-types.model';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DocumentTypeService } from '../types.service';

@Component({
  selector: 'app-alldocuments-types-mobile',
  templateUrl: './alldocuments-types-mobile.component.html',
  styleUrls: ['./alldocuments-types-mobile.component.scss']
})
export class AlldocumentsTypesMobileComponent implements OnInit, OnDestroy, OnChanges {
  @Input() selectedType: DocumentType | null = null;
  @Input() allowedInvoiceTypes: number[] = []; // New input for filtering invoice types
  @Output() typeChange = new EventEmitter<DocumentTypeEvent>();

  documentTypes: DocumentType[] = [];
  filteredDocumentTypes: DocumentType[] = [];
  showAllTypes: boolean = false;
  selectedValue: DocumentType | null = null;
  private destroy$ = new Subject<void>();

  constructor(public translate: TranslateService, private documentTypeService: DocumentTypeService) { }

  async ngOnInit(): Promise<void> {
    this.documentTypes = await this.documentTypeService.getDocumentTypes();
    this.filterDocumentTypes();
    this.selectedType = null;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['allowedInvoiceTypes'] && !changes['allowedInvoiceTypes'].firstChange) {
      this.filterDocumentTypes();
    }
    if (changes.selectedType) {
      this.selectedValue = this.selectedType;
    }
  }

  toggleShowAllTypes(): void {
    this.showAllTypes = !this.showAllTypes;
  }

  onTypeChange(value: DocumentType): void {
    this.selectedValue = value;
    this.typeChange.emit({
      value,
      originalEvent: undefined
    });
  }

  isTypeSelected(type: DocumentType): boolean {
    return this.documentTypeService.isTypeSelected(this.selectedType, type);
  }

  private filterDocumentTypes(): void {
    if (this.allowedInvoiceTypes.length === 0) {
      // If no allowed types specified, show all types
      this.filteredDocumentTypes = [...this.documentTypes];
    } else {
      // Filter document types based on allowed invoice types
      this.filteredDocumentTypes = this.documentTypes.filter(docType => 
        this.allowedInvoiceTypes.includes(parseInt(docType.code))
      );
    }
  }
}
